import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Admin from "./pages/dashboard/Admin";
import Employee from "./pages/Employee";
import Signup from "./pages/auth/Signup";
import Dashboard from "./pages/dashboard/Dashboard";
import DashboadLayout from "./Layout/DashboardLayout/DashboadLayout";
import Admins from "./pages/dashboard/Admins";
import AuthLayout from "./Layout/AuthLayout/AuthLayout";
import CreateEmployee from "./pages/dashboard/CreateEmployee";
import Signin from "./pages/auth/Signin";
import UserSignin from "./pages/users/Signin";
import CreateCompany from "./pages/dashboard/CreateCompany";
import CompanyDetail from "./pages/dashboard/companyDetail";
import UsersLayout from "./Layout/UsersLayout/UsersLayout";
import Supervisor from "./pages/users/Supervisor";
import FormResponse from "./pages/dashboard/FormResponse";
import AllEmployee from "./pages/dashboard/AllEmployee";
import AllSupervisor from "./pages/dashboard/AllSupervisor";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AuthLayout />}>
          <Route path="/" element={<Signin />} />
        </Route>
        <Route path="/dashboard" element={<DashboadLayout />}>
          {/* <Route path="/dashboard/companies">
            <Route path="/dashboard/companies" element={<CreateCompany />} />
            <Route path=":companyId" element={<CompanyDetail />} />
          </Route> */}
          {/* <Route index element={<CompanyDetail />} /> */}
          <Route path="/dashboard/admins" element={<Admins />} />
          <Route path="/dashboard/createform" element={<Admin />} />

          <Route path="/dashboard/allsupervisor" element={<AllSupervisor />} />
          <Route
            path="/dashboard/create-employee"
            element={<CreateEmployee />}
          />
          <Route path="/dashboard/companies">
            <Route path="/dashboard/companies" element={<CreateCompany />} />
            <Route
              path="/dashboard/companies/:companyId/employees"
              element={<AllEmployee />}
            />
            <Route
              path="/dashboard/companies/:companyId/supervisors"
              element={<AllSupervisor />}
            />
            <Route path=":companyId" element={<CompanyDetail />} />
            <Route
              path="/dashboard/companies/responses/:companyId"
              element={<FormResponse />}
            />
          </Route>
        </Route>

        <Route path="/auth" element={<AuthLayout />}>
          <Route path="/auth/sign-up" element={<Signup />} />
          <Route path="/auth/sign-in" element={<Signin />} />
        </Route>

        <Route path="/users" element={<UsersLayout />}>
          <Route path="/users/sign-in" element={<UserSignin />} />
          <Route path="/users/supervisor" element={<Supervisor />} />
          <Route path="/users/employee" element={<Employee />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
